export default {
  data() {
    return {
      filter: {
        sysType: "", // 定制系统编码
        sysName: "", // 定制系统名称
      },
      searchCCompaniesData: [],
      searchCCompaniesTimer: null,
    };
  },
  watch: {
    "filter.sysName"(val) {
      if (!val) {
        this.filter.sysType = "";
        this.searchCCompaniesData.splice(0);
      }
    },
  },
  methods: {
    // 下拉联想数据为空时 对应数据重置
    $_clearSearchCCompanyData(key) {
      this.filter.sysType = "";
      this.filter.sysName = "";
    },
    $_searchCCompanies(sysName, cb) {
      if (this.searchCCompaniesTimer) {
        clearTimeout(this.searchCCompaniesTimer);
      }
      this.searchCCompaniesTimer = setTimeout(() => {
        this.$service
          .post("getCustomCompanys", {
            sysName,
            pageNow: 1,
            pageSize: 40,
          })
          .then(result => {
            if (result.$.checkResult(result, true)) {
              let rows = result.data.rows.splice(0);
              this.searchCCompaniesData = rows;
              cb(rows);
            }
          });
      }, 100);
    },
    // 选择对应供应商
    $_selectCCompany(item) {
      this.filter.sysType = item.sysType;
      this.filter.sysName = item.sysName;
    },
  },
};
